import { CustomBottomBar, PdfViewer } from '@components';
import minorInfosPdf from '@assets/pdf/minor-infos.pdf';
import { Button, Container, Typography } from '@design-system';
import { useMinorInfosPageVM } from './useMinorInfosPageVM';

export const MinorInfosPage: React.FC = () => {
    const { handleNextStep } = useMinorInfosPageVM();

    return (
        <Container>
            <PdfViewer file={minorInfosPdf} setHasSeenAllPages={() => {}} />

            <CustomBottomBar>
                <Button variant="primary" color="marine" size="fullwidth" onClick={handleNextStep}>
                    <Typography intrinsic="h4">Valider</Typography>
                </Button>
            </CustomBottomBar>
        </Container>
    );
};
